import React, { Component } from 'react';
import { Flex, Heading, Text, Link, Button, Card, Tooltip } from 'core/components';
import NonCloudDeviceCollection from 'app/stores/device/NonCloudDeviceCollection';
import AdminTable from 'app/components/admin/AdminTable';
import DeviceClassIcon from 'app/components/nms/DeviceClassIcon';
import SiteLink from 'app/components/links/SiteLink';
import VendorLogo from 'app/components/VendorLogo';
import DeviceDetailsStatusTag from 'app/views/metrics/components/DeviceDetailsStatusTag';

class DeviceInventoryToolResult extends Component {
  state = {
    collection: new NonCloudDeviceCollection()
  };

  componentDidMount() {
    const { collection } = this.state;
    const { tool } = this.props;
    const { raw_result = {} } = tool;
    collection.add(raw_result);
  }

  get columns() {
    return [
      {
        label: 'Status',
        id: 'statusDisplay',
        value: 'statusDisplay',
        name: 'statusDisplay',
        computed: true,
        ellipsis: false,
        width: 90,
        alignItems: 'center',
        renderer: ({ model }) => (
          <DeviceDetailsStatusTag device={model} small unavailable={!model.isNMS && !model.isICMP} />
        )
      },
      {
        label: 'Name',
        id: 'name',
        value: 'name',
        name: 'device_name',
        ellipsis: false,
        minWidth: 200,
        flexBasis: 160,
        referencedFields: ['device_name', 'device_subtype', 'device_status', 'labels'],
        alignItems: 'center',
        renderer: ({ model }) => {
          const icon = (
            <DeviceClassIcon deviceModel={model} fillSpaceIfNull showTooltip tooltipPosition="top" iconSize={24} />
          );

          return (
            <Flex flexDirection="column">
              <Flex>
                <Link ellipsis to={`/v4/infrastructure/devices/${model.get('device_name')}`}>
                  <Flex gap="4px" alignItems="center">
                    {icon}
                    <Text ellipsis fontWeight="bold">
                      {model.get('device_name')}
                    </Text>
                  </Flex>
                </Link>
              </Flex>
            </Flex>
          );
        }
      },
      {
        label: 'Site',
        id: 'site',
        value: 'site',
        name: 'site_name',
        renderer: ({ model, value }) => {
          const site = model.get('site_id');
          return site ? <SiteLink siteId={site}>{value}</SiteLink> : <Text muted>None</Text>;
        }
      },
      {
        label: 'Vendor',
        name: 'vendor',
        id: 'vendor',
        value: 'vendor',
        minWidth: 120,
        renderer: ({ value: vendor }) => {
          const icon = (
            <Tooltip content={vendor} position="top">
              <VendorLogo
                icon
                name={vendor}
                logoStyle={{
                  width: 24,
                  height: 24,
                  marginTop: 4
                }}
              />
            </Tooltip>
          );

          return (
            <Flex alignItems="center" gap={1}>
              {icon} <Text ellipsis>{vendor}</Text>
            </Flex>
          );
        }
      },
      {
        label: 'Model',
        name: 'model',
        id: 'model',
        value: 'model'
      },
      {
        label: 'Flow IP',
        id: 'sending_ips',
        value: 'sending_ips',
        name: 'sending_ips',
        flexBasis: 125,
        renderer: ({ value }) => value.join(', ')
      }
    ];
  }

  render() {
    const { collection } = this.state;
    const { tool, onCloseToolResult } = this.props;

    return (
      <Card
        p={0}
        className="tool-result-device-inventory"
        display="flex"
        flexDirection="column"
        gap={2}
        minHeight={600}
        height="100%"
        overflow="hidden"
      >
        <Flex alignItems="center" justifyContent="space-between" p={2} pb={0}>
          <Heading level={5} m={0} flex={1}>
            {tool.title || 'Device Inventory Result'}
          </Heading>
          <Flex alignItems="center" gap={1}>
            <Button text="Close" small icon="cross" onClick={() => onCloseToolResult(tool)} color="muted" minimal />
          </Flex>
        </Flex>
        <Flex flexDirection="column" px={1} pb={1} flex={1}>
          <AdminTable
            ariaLabel="Devices"
            collection={collection}
            fetchCollectionOnMount={false}
            onRowClick={this.handleRowClick}
            rowHeight={48}
            columns={this.columns}
            selectedLabelSingular="device"
            selectedLabelPlural="devices"
            tableHeaderControlsPosition="afterSearch"
          />
        </Flex>
      </Card>
    );
  }
}

export default DeviceInventoryToolResult;
